(function() {
  function isColorLabel(text) {
    return (text || '').trim().toLowerCase().indexOf('color') === 0;
  }

  function getColorFieldset() {
    var variantSelects = document.querySelector('variant-selects, variant-radios');
    if (!variantSelects) return null;
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && isColorLabel(legend.textContent)) return fieldsets[i];
    }
    return null;
  }

  function getColorDropdownWrapper() {
    var variantSelects = document.querySelector('variant-selects, variant-radios');
    if (!variantSelects) return null;
    var wrappers = variantSelects.querySelectorAll('.product-form__input--dropdown');
    for (var i = 0; i < wrappers.length; i++) {
      var label = wrappers[i].querySelector('label');
      if (label && isColorLabel(label.textContent)) return wrappers[i];
    }
    return null;
  }

  function getSelectedColor() {
    var colorFieldset = getColorFieldset();
    if (colorFieldset) {
      var colorInput = colorFieldset.querySelector('input[type="radio"]:checked');
      if (colorInput) return colorInput.value;
    }
    var dropdownWrapper = getColorDropdownWrapper();
    if (dropdownWrapper) {
      var select = dropdownWrapper.querySelector('select');
      if (select) return select.value;
    }
    return null;
  }

  function filterGalleryByColor(selectedColor) {
    if (!selectedColor) return;
    var color = selectedColor.toLowerCase().trim();
    var slides = document.querySelectorAll('.product__media-list li[data-media-id], .thumbnail-list li');
    slides.forEach(function(slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var alt = (img.getAttribute('alt') || '').toLowerCase().trim();
      if (alt.indexOf('variant-') === 0) {
        var imgColor = alt.replace('variant-', '').trim();
        slide.style.display = (imgColor === color) ? '' : 'none';
      }
    });
  }

  function runFilter() {
    var color = getSelectedColor();
    if (color) filterGalleryByColor(color);
  }

  var galleryObserver = null;

  function watchGalleryMutations() {
    var gallery = document.querySelector('.product__media-list');
    if (!gallery || galleryObserver) return;
    galleryObserver = new MutationObserver(function() {
      runFilter();
    });
    galleryObserver.observe(gallery, { childList: true, subtree: true });
  }

  function init() {
    runFilter();
    watchGalleryMutations();

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function(event) {
        var target = event && event.data && event.data.target;
        if (target) {
          var fieldset = target.closest('fieldset');
          var legend = fieldset ? fieldset.querySelector('legend') : null;
          if (legend && !isColorLabel(legend.textContent)) return;
        }
        runFilter();
      });
    }

    document.addEventListener('click', function(e) {
      var label = e.target.closest('label');
      if (!label) return;
      var input = document.getElementById(label.htmlFor);
      if (!input || input.type !== 'radio') return;
      var fieldset = input.closest('fieldset');
      var legend = fieldset ? fieldset.querySelector('legend') : null;
      if (!legend || !isColorLabel(legend.textContent)) return;
      filterGalleryByColor(input.value);
    });

    document.addEventListener('change', function(e) {
      if (e.target.tagName !== 'SELECT') return;
      var wrapper = e.target.closest('.product-form__input--dropdown');
      var label = wrapper ? wrapper.querySelector('label') : null;
      if (!label || !isColorLabel(label.textContent)) return;
      filterGalleryByColor(e.target.value);
    });
  }

  function waitForPubSub(attempts) {
    if (attempts <= 0) {
      init();
      return;
    }
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      init();
    } else {
      setTimeout(function() { waitForPubSub(attempts - 1); }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { waitForPubSub(20); });
  } else {
    waitForPubSub(20);
  }
})();
